<template>
  <div class="d-flex align-center justify-center" style="height: 100vh;">
    <v-progress-circular :size="80" color="primary" indeterminate width="6"></v-progress-circular>
  </div>
</template>
<script>
export default {
  created () {
    const { code } = this.$route.query || {}
    if (code) {
      if (code) window.opener.postMessage({ authFrom: 'microsoft', code }, '*')
      self.close()
    }
  }
}
</script>
